import { render } from "./StudioPage.vue?vue&type=template&id=075cbfd4"
import script from "./StudioPage.vue?vue&type=script&lang=js"
export * from "./StudioPage.vue?vue&type=script&lang=js"

import "./StudioPage.vue?vue&type=style&index=0&id=075cbfd4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__